export default __webpack_public_path__ + "static/media/bg_blocks_virtual.986113c5.jpg";